/**
 * Logger utility that only outputs in development mode
 * In production builds, logging is disabled to prevent information leakage
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args: unknown[]): void => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  warn: (...args: unknown[]): void => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  error: (...args: unknown[]): void => {
    // Errors are always logged for debugging production issues
    // but without sensitive details
    if (isDevelopment) {
      console.error(...args);
    } else {
      // In production, log a sanitized version
      console.error('An error occurred. Check server logs for details.');
    }
  },

  debug: (...args: unknown[]): void => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },

  info: (...args: unknown[]): void => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
};

export default logger;
